import React from "react";
import { Callout, Spinner } from "@blueprintjs/core";
import { useAuth } from "../../auth/AuthContext";
import { useOrg } from "../../auth/OrgContext";

export default function Overview() {
  const { tier, loading } = useAuth();
  const { currentOrg, isLoading: orgLoading } = useOrg();

  if (loading || orgLoading) {
    return (
      <div style={{ textAlign: "center", padding: "4rem" }}>
        <Spinner intent="primary" size={40} />
      </div>
    );
  }

  const hasSub = tier === "pro" || tier === "enterprise";

  if (!hasSub) {
    return (
      <div style={{ textAlign: "center", padding: "4rem" }}>
        <Callout
          title="Subscription required"
          intent="warning"
          style={{
            marginBottom: "2rem",
            maxWidth: "600px",
            marginInline: "auto",
          }}
        >
          You need an active subscription to view the dashboard.{" "}
          <a href="/account">Manage your plan&nbsp;→</a>
        </Callout>
      </div>
    );
  }

  if (!currentOrg) {
    return (
      <div style={{ textAlign: "center", padding: "4rem" }}>
        <Callout
          title="No organization selected"
          intent="warning"
          style={{
            marginBottom: "2rem",
            maxWidth: "600px",
            marginInline: "auto",
          }}
        >
          Please select or create an organization first.{" "}
          <a href="/account/organizations">Manage organizations&nbsp;→</a>
        </Callout>
      </div>
    );
  }

  return (
    <div>
      {/* Dashboard header removed, handled by MainLayout */}
      {(!currentOrg || !hasSub) ? null : (
        <div style={{ textAlign: "center", padding: "4rem" }}>
          <Callout
            title={`Welcome to ConformIQ, ${currentOrg.name}!`}
            intent="primary"
            style={{
              marginBottom: "2rem",
              maxWidth: "600px",
              marginInline: "auto",
            }}
          >
            You can manage your account settings and view your subscription details
            in the left sidebar.
          </Callout>
        </div>
      )}
    </div>
  );
}
